import { useEffect } from "react"
import { useDispatch } from "react-redux"

import NotesComponent from "../notes/NotesComponent"
import TabHeader from "../../tab/TabHeader"
import LiabilityTabControls from "../liability/LiabilityTabControls"
import { insuranceActions } from "../../../../store/insurance"
import MedpayDetails from "./MedpayDetails"
import ItemsCounter from "../Shared/ItemsCounter"
import MedPayTags from "./MedPayTags"

const MedpayTab = ({ inWorkQ }) => {

    const dispatch = useDispatch()

    useEffect(() => {
        return () => {
            dispatch(insuranceActions.setSearchResult(null))
            dispatch(insuranceActions.setClearAsyncResults(false))
        }
    }, [])

    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>MedPay/PIP</h2>
                <ItemsCounter type={'mp_pip_um'}/>
                <NotesComponent noteTypeId={2} inWorkQ={inWorkQ}/>
                <MedPayTags />
            </div>
            <LiabilityTabControls folder={'mp_pip_um'} apiCase={'case_mp_pip_um'}/>
        </TabHeader>
        <div>
            <MedpayDetails branch={'medpay'}/>
        </div>
    </>
}

export default MedpayTab